export enum ConfigLevelType {
    RootNode = -1,
    Config,
    Branch,
    Terminal,
    Application
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/enums/config-level-type.enum.ts